import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, delay, retry, shareReplay, take } from 'rxjs';
import { Chart } from 'src/models/chart';
import { Report } from 'src/models/report';
import { AppSettings } from '../app-settings';
import { LoginService } from './login.service';
import { ReportData } from 'src/models/reportData';

@Injectable({
    providedIn: 'root',
})
export class ReportsService {
    public showAttendeeEvent = new EventEmitter<number>();

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings, private userService: LoginService) { }

    getReports(userId: number, reportTypeId: number): Observable<Report[]> {
        let url = this.appSettings.apiBaseUrl() + 'Reports/GetReports?userId=' + userId + '&reportTypeId=' + reportTypeId

        return this.http.get<Report[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getReportById(reportID: number, month: number, year: number, profileId: number,
        planDate: string, serviceId: number, profileTypeId: number): Observable<any> {
        let userId = this.userService.currentUser?.UserId;

        let url = this.appSettings.apiBaseUrl() + 'Reports/GetReportById?reportId=' + reportID + "&userId=" + userId +
            '&profileId=' + profileId + "&serviceId=" + serviceId + '&year=' + year + '&month=' + month + '&planDate=' + planDate +
            '&profileTypeId=' + profileTypeId;

        return this.http.get<any>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getProfileReport(reportId: number, profileId: number, serviceId: number): Observable<ReportData[]> {
        let url = this.appSettings.apiBaseUrl() + 'Reports/GetProfileReport?reportId=' + reportId + '&profileId=' + profileId + "&serviceId=" + serviceId;

        return this.http.get<ReportData[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getChartById(chartId: number): Observable<Chart> {
        let userId = this.userService.currentUser?.UserId;
        let url = this.appSettings.apiBaseUrl() + 'Reports/GetChartByID?chartId=' + chartId + "&userId=" + userId;

        return this.http.get<Chart>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

}